export default __webpack_public_path__ + "static/media/how_bg.2ff6bce4.svg";